import styles from "./MainHeader.module.scss"
import {Heading, Tag, Button} from "ui-components";
import AccountMenu from "./AccountMenu"
import UserMenu from "./UserMenu"
import {Link} from "react-router-dom"
import {ReactComponent as MainLogo} from "./images/NewMainLogo.svg";
import {ReactComponent as ConsoleIcon} from "./images/NewConsoleIcon.svg";
import {ReactComponent as LeftNavHamburger} from "./images/LeftNavHamburger.svg";
import {css} from '@emotion/react';
import {useSelector} from "react-redux";
import {RootState} from "../../../store";
import {useConsole} from "../../console/consoleStore";
import AccountMenuDataTest from "../../../testUtils/accountMenuDataTest.ts";
import {useState} from "react";
import MainNav from "modules/app/components/MainNav.tsx";
import navDataTest from "testUtils/navDataTest.ts";

const productNameCss = css`
    display: flex;
    align-items: center;
    padding-left: 18px;
`;

const leftNavHamburgerCss = (isNavOpen: boolean) => css`
    box-shadow: 0 -1px 0 0 var(--drop-shadow) inset;
    padding-bottom: 1px;
    --hamburger-icon-main-nav: var(${isNavOpen ? "--hover-background" : "--content-background"});
    &:hover{
        --hamburger-icon-main-nav: var(--button-primary-bg-disabled);
    }
`


const Widgets = ({isFirstTimeUser}: { isFirstTimeUser: boolean }) => {
    const setIsConsoleOpen = useConsole((state) => state.setIsConsoleOpen);
    return <div className={styles.widgets}>
        {!isFirstTimeUser && <>
            {<Button className={styles.widgetButtonNewNav} onClick={() => {
                setIsConsoleOpen(true);
            }} variant="icon" color="secondary" dataTestId={AccountMenuDataTest.cloudShell.cloudShellButtonGlobal}><ConsoleIcon style={{width:25, height: 21}}/></Button>}
            <AccountMenu/>
        </>}
        <UserMenu/>
    </div>
}


const MainHeader = ({isFirstTimeUser}: { isFirstTimeUser: boolean }) => {
    const isDemo = useSelector((state: RootState) => state.tenancy.isDemo);
    const [isNavOpen, setIsNavOpen] = useState<boolean>(false)


    return <div className={styles.base} style={{paddingLeft: 0}}>
        <Button dataTestId={navDataTest.hamburgerNav} css={leftNavHamburgerCss(isNavOpen)} variant={"icon"} onClick={()=>{setIsNavOpen(prev => !prev)}}><LeftNavHamburger/></Button>
        <MainNav isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen}/>
        <div css={productNameCss}>
            <Link to="/" css={productNameCss}>
                <MainLogo style={{marginRight: 16}}/>
                <Heading level="16" bold style={{marginRight: 16}}>Workload Factory</Heading>
            </Link>
            {isDemo && <Tag color="chart-1">Demo</Tag>}
        </div>

        <Widgets isFirstTimeUser={isFirstTimeUser}/>
    </div>
}

export default MainHeader;
